import { put, delay } from 'redux-saga/effects';
import axios from '../../axios-local-api';
import * as actions from '../actions';

export function* getPropertyManagerSaga(action) {
  const masterAcct = yield sessionStorage.getItem('masterAcct');
  const accountNumber = yield sessionStorage.getItem('accountNumber');
  if (!action.single) {
    yield put(actions.initPropertyManagerStart());
    try {
      let response = {};
      response = yield axios.get(
        '/psp/propertyAddress/' + masterAcct,
        { validateStatus: () => true }
      )

      if (response.status === 200) {
        yield put(actions.setPropertyManagerDetails(response.data.accounts[0]))
        yield put(actions.setPropertyManagerSuccess());
      } else {
        yield put(actions.setPropertyManagerFailed());
      }

    } catch (error) {
      yield put(actions.setPropertyManagerFailed());
    }
  } else {
    try {
    /*  WINSERVER Auth.startApp() guarantees that:
      * (logic is inside the anonymous function passed to Async.waterfall)
      *
      * MASTERACCT prop in the JWT body will be `null`
      * if the classification is not TENANT or MASTER.
      *
      * Thus, we must check for `null` here.
      */
      if (masterAcct === 'null') {
        return;
      }
      const response = yield axios.get(
        '/psp/bulkMasterAccount/' + masterAcct + '/accountNumber/' + accountNumber,
        { validateStatus: () => true }
      )
      if (response.status === 200) {
        if (response.data) {
          yield put(actions.setTenant(response.data))
        }
      }

    } catch (error) {
      yield put(actions.setPropertyManagerFailed());
    }
  }
}

export function* getPropertyManagerTenantDetailsSaga(action) {
  const masterAcct = yield sessionStorage.getItem('masterAcct')

  yield put(actions.initPropertyManagerTenantDetailsStart(action.filter));

  try {
    // WIN-1603: Fetch all tenant data in one shot — filtering/pagination is client-side only
    const response = yield axios.get('/psp/getInfo/' + masterAcct, { validateStatus: () => true })

    if (response.status === 200) {
      yield put(actions.setPropertyManagerTenantDetails(response.data));
      yield put(actions.setPropertyManagerTenantDetailsSuccess());
    } else {
      yield put(actions.setPropertyManagerTenantDetailsFailed());
    }

  } catch (error) {
    yield put(actions.setPropertyManagerTenantDetailsFailed());
  }
}

export function* restoreServiceTenantAccountSaga(action) {
  //console.log('NNNN')
  yield put(actions.initPropertyManagerStart());

  try {
    let response = {};
    response = yield axios.put(
      '/psp/enable/' + action.routerMac,
      {
        tenantName: action.tenantName,
        propertyName: action.propertyName,
        tenantAccountNumber: action.tenantAccountNumber,
        tenantAccountDivisionId: action.tenantAccountDivisionId,
        tenantAccountRouterMac: action.tenantAccountRouterMac,
        bulkMasterAccount: action.bulkMasterAccount
      }
    )
    if (response.status === 200) {
      yield put(actions.setPropertyManagerSuccess());
      yield delay(1000);

      if (action.masterAccNum) {
        yield put(actions.getPropertyManagerTenantDetails());

      } else {
        yield put(actions.getPropertyManagerDetails(true));
      }
      yield put(actions.restoreServiceTenantAccountSuccess());
    } else {
      yield put(actions.setPropertyManagerFailed());
      yield put(actions.restoreServiceTenantAccountFailed())
    }

  } catch (error) {
    yield put(actions.setPropertyManagerFailed());
    yield put(actions.restoreServiceTenantAccountFailed())
  }
}

export function* resumeSpecReadyServiceTenantAccountSaga(action) {
  //console.log('askhhdkjahsdkahsskdh ::::', action);
  yield put(actions.initPropertyManagerStart());

  try {
    let response = {};
    response = yield axios.post(
      '/psp/resume',
      {
        rMac: action.routerMac
      }
    )
    if (response.status === 200) {
      yield put(actions.setPropertyManagerSuccess());
      const parsedData = {
        ...response.data,
        data: JSON.parse(response.data.data)
      };
      yield put(actions.setSpectrumStatus(parsedData))
      yield delay(1000);

      if (action.masterAccNum) {
        yield put(actions.getPropertyManagerTenantDetails());

      } else {
        yield put(actions.getPropertyManagerDetails(true));
      }
      yield put(actions.restoreServiceTenantAccountSuccess());
    } else {
      yield put(actions.setPropertyManagerFailed());
      yield put(actions.restoreServiceTenantAccountFailed());
    }

  } catch (error) {
    yield put(actions.setPropertyManagerFailed());
    yield put(actions.restoreServiceTenantAccountFailed());
  }
}


